import { useAuthStore } from '../../stores/auth/useAuthStore'
import { useAppHandlers } from '../actions/app/useAppHandlers'
import {
    CampaignsBulkAnnouncementAction,
    shouldShowCampaignsBulkActionAnnouncement,
} from './campaignsBulkActionAnnouncement'

export const useCampaignsBulkActionAnnouncement = () => {
    const { store: { user, trial, lifetime, subscription, workspace } } = useAuthStore()
    const { setCampaignsAnnouncementModal } = useAppHandlers()

    /** Pure check — true when the announcement is still due for this user/action. */
    const shouldShowAnnouncementFor = (action: CampaignsBulkAnnouncementAction): boolean =>
        shouldShowCampaignsBulkActionAnnouncement(action, { userId: user?._id, trial, lifetime, subscription, workspace })

    /**
     * Shows the one-time Campaigns announcement modal for the given bulk action.
     * Returns true when the modal was shown — the caller should stop; the original
     * action continues via onContinue once the modal is closed.
     */
    const showCampaignsAnnouncementIfNeeded = (
        action: CampaignsBulkAnnouncementAction,
        onContinue?: () => void
    ): boolean => {
        if (!shouldShowAnnouncementFor(action)) return false
        setCampaignsAnnouncementModal(onContinue)
        return true
    }

    return { showCampaignsAnnouncementIfNeeded, shouldShowAnnouncementFor }
}
